import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import {
  blueGreyMui,
  blueMui,
  deepPurpleMui,
  greyMui,
  orangeMui,
  rydeColors,
} from "@ryde/theme";

export const RelatedEntitiesUnitStyled = styled.span`
  color: ${blueMui._800};
  font-weight: 600;
`;

export const RelatedEntitiesIdMetaStyled = styled.span`
  .id-meta {
    color: ${greyMui._600};
    font-weight: 500;
  }

  .id-value {
    color: ${orangeMui._800};
    font-weight: 600;
  }
`;

export const RelatedEntitiesErrorButtonStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "related-entities-error-button",
  },
)`
  margin-top: 8px;
  margin-inline-start: 5px;
  display: flex;
  justify-content: flex-start;

  button {
    padding: 0;
  }
`;

export const RelatedEntitiesHeaderIconStyled = styled.span.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "related-entities-header-icon",
  },
)<{ $alwaysVisible?: boolean }>`
  display: inline-flex;
  align-items: center;
  margin-inline-start: 13px;
  opacity: ${({ $alwaysVisible }) => ($alwaysVisible ? 1 : 0)};
  transition: opacity 0.3s ease-in-out;
  flex-shrink: 0;
  vertical-align: middle;

  .related-entities-header-button {
    padding: 2px;
    color: ${({ $alwaysVisible }) =>
      $alwaysVisible ? blueGreyMui._100 : blueGreyMui._400};
    transition: color 0.2s ease-in-out;

    &:hover {
      color: ${blueGreyMui._600};
      background-color: ${greyMui._100};
    }
  }
`;

export const RelatedEntitiesHeaderIconContainer = styled.span`
  display: inline-flex;
  align-items: center;
  max-width: 100%;

  &:hover .related-entities-header-icon-wrapper {
    opacity: 1;
  }
`;

export const RelatedEntitiesDrawerActionsStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "related-entities-drawer-actions",
  },
)`
  display: flex;
  align-items: center;
  gap: 2px;
  margin-inline-start: auto;
  margin-inline-end: 4px;
`;

export const RelatedEntitiesTableStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "related-entities-table",
})`
  padding: 8px 4px 12px;
  min-height: 280px;
  display: flex;
  flex-direction: column;

  .related-entities-table-inner {
    width: 100%;
    table-layout: fixed;
    border-collapse: separate;
    border-spacing: 0;
    background-color: ${rydeColors.white};
    border: 1px solid ${greyMui._200};
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);

    th,
    td {
      padding: 10px 12px;
      text-align: start;
      border-bottom: 1px solid ${greyMui._200};
      vertical-align: top;
    }

    tr:last-child td {
      border-bottom: none;
    }

    th {
      background-color: ${greyMui._50};
      font-weight: 600;
      color: ${greyMui._800};
      font-size: 13px;
    }

    th.entity-type-col,
    td.entity-type-cell {
      width: 29%;
      white-space: nowrap;
      padding-inline-end: 12px;
    }

    td.entity-type-cell {
      font-weight: 500;
      color: ${greyMui._700};

      .entity-count-sep {
        color: ${greyMui._400};
        font-weight: 400;
      }

      .entity-count {
        color: ${greyMui._500};
        font-weight: 500;
      }
    }

    th.relation-ids-col,
    td.relation-ids-cell {
      width: 71%;
      word-break: break-word;
    }
  }

  .related-entities-empty {
    padding: 24px 16px;
    text-align: center;
    color: ${greyMui._600};
  }

  .related-entities-loading {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 64px 16px;
    min-height: 320px;
  }

  .related-entities-loading-caption {
    margin: 0;
    color: ${deepPurpleMui._700};
    font-weight: 600;
  }
`;
export const LinkToRelatedEntityStyled = styled.span`
  color: ${blueMui.A400};
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;
